export const PATHS = {
  ABOUT: '/about',
  WORKS: '/works',
  BOOKS: '/book-reviews'
}